import { useState } from "react";
import { useSwipeable } from "react-swipeable";

const ImageCarousel = ({ photos, staff, owner, userId, navigate, viewPhotos }) => {
    const [activeCarouselIndex, setActiveCarouselIndex] = useState(0);

    const handleCarouselNext = () => {
        if (!photos.length) {
            return;
        }

        setActiveCarouselIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1));
    };

    const handleCarouselPrev = () => {
        if (!photos.length) {
            return;
        }

        setActiveCarouselIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1));
    };

    const swipeHandlers = useSwipeable({
        onSwiped: (eventData) => {
            const { dir } = eventData;
            if (dir === "Left") {
                handleCarouselNext();
            } else if (dir === "Right") {
                handleCarouselPrev();
            }
        },
    });

    let photosToRender = [];
    if (!photos.length) {
        photosToRender = [
            <div key={0} className={`flex-shrink-0 w-full block`}>
                <div
                    className="w-full bg-gray-200"
                    style={{
                        height: 400,
                        backgroundSize: "cover",
                        backgroundPosition: "top",
                    }}
                ></div>
            </div>,
        ];
    } else {
        photosToRender = photos.map((p, i) => (
            <div key={i} className={`flex-shrink-0 w-full ${i === activeCarouselIndex ? "block" : "hidden"}`}>
                <div
                    className="w-full"
                    style={{
                        backgroundImage: `url("${p.cdn_url}")`,
                        height: 400,
                        backgroundSize: "cover",
                        backgroundPosition: "top",
                    }}
                ></div>
            </div>
        ));
    }

    return (
        <div className="relative md:hidden heap-ignore">
            <div {...swipeHandlers} className="flex overflow-x-auto">
                {photosToRender}
            </div>
            <button
                onClick={() => {
                    if (staff) {
                        navigate(`/staff/split-members/${userId}/public-profile/photos`);
                    } else if (owner) {
                        viewPhotos();
                    } else {
                        navigate(`/family/donors/${userId}/photos`);
                    }
                }}
                className="text-secondary font-normal absolute bottom-1 right-0 py-3 px-4 m-2 bg-white text-black rounded-full z-10"
            >
                View Photos
            </button>
        </div>
    );
};

export default ImageCarousel;
